// extracted by mini-css-extract-plugin
export default {"popper__body":"Popper_popper__body__91hsV","popper__user":"Popper_popper__user__RbNHb","popper__item":"Popper_popper__item__psXlU"};